import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  queryKey: ['framework-agreement-buyers'],
  queryOptions: {},
};

const getFrameworkAgreementBuyers = async (frameworkAgreementId, queryStringParams) => {
  const queryString = qs.stringify({ companytype: 'buyer', ...queryStringParams });

  const {
    data: { data: buyers, total },
  } = await axios.get(`/api/framework_agreements/${frameworkAgreementId}/companies?${queryString}`);

  return { buyers, total };
};

export const useFrameworkAgreementBuyers = (frameworkAgreementId, queryParams = {}) => {
  const { page, limit, search, includeInactive, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, frameworkAgreementId],
    () => getFrameworkAgreementBuyers(frameworkAgreementId, queryStringParams),
    {
      select: ({ buyers, total }) => ({ buyers, total }),
      initialData: { buyers: [], total: 0 },
      ...queryOptions,
    }
  );
};
